/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCalendarNote = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M6.998 2v2h-5v18h7v-2h-5V6h3v2h2V6h6v2h2V6h3v3h2V4h-5V2h-2v2h-6V2z" />
        <path d="M20 11h-6v1h-3v11h12V12h-3zm-7 3h1v2h6v-2h1v7h-8zm3-1h2v1h-2zm-7-1H7v-2h2zm-2 4h2v-2H7z" />
      </g>
    </g>
  </Icon>
);
export { SvgCalendarNote as CalendarNote };
